import React, {Component} from 'react';
import {Navigation} from './components/navigation/Navigation';
import {Home} from "./views/home/Home";
import {Footer} from "./components/footer/Footer";
import {Route} from 'react-router-dom';
import {ConnectedSwitch} from "./util/ConnectedSwitch";
import {SearchView} from "./views/search/SearchView";
import {setLanguage} from "redux-i18n";
import {connect} from 'react-redux';
import {ProductCategory} from "./views/products/ProductCategory";
import {ProductCategories} from "./views/products/ProductCategories";
import {Support} from "./views/support/Support";
import {ContactUsView} from "./views/contact-us/ContactUsView";
import {AboutUsView} from "./views/about-us/AboutUsView";
import {NewsView} from "./views/news/NewsView";
import {ProductView} from "./views/products/ProductView";
import {SearchBar} from "./components/search-bar/SearchBar";
import {NewsListView} from "./views/news/NewsList";
import {NotFound} from "./views/not-found/NotFound";
import {ProgressIndicator} from "./components/modal/ProgressIndicator";

class AppContainer extends Component {

  constructor(props) {
    super(props);

    this.state = {
      showProgress: false
    };

  }

  componentWillMount(){
    this.props.setLanguage(this.props.match.params.lang);
  }

  componentWillReceiveProps(nextProps){
    if(typeof nextProps.resolve_progress === 'boolean'){
      if(nextProps.resolve_progress){
        setTimeout(() => {
          if(this.props.resolve_progress) {
            this.setState({
              showProgress: true
            });
          }
        },500);
      } else {
        this.setState({
          showProgress: false
        });
      }

    }
  }

  render() {
    return (
      <div className={"app-container"}>
        <main>
          <ConnectedSwitch>
            <Route exact path='/:lang/' component={Home}/>
            <Route exact path='/:lang/solutions/:solution_slug/products/:product_slug' component={ProductView}/>
            <Route exact path='/:lang/solutions/:solution_slug' component={ProductCategory}/>
            <Route exact path='/:lang/solutions' component={ProductCategories}/>
            <Route exact path='/:lang/support' component={Support}/>
            <Route exact path='/:lang/contact' component={ContactUsView}/>
            <Route exact path='/:lang/news/:news_slug' component={NewsView}/>
            <Route exact path='/:lang/news/' component={NewsListView}/>
            <Route exact path='/:lang/about' component={AboutUsView}/>
            <Route exact path='/:lang/search' component={SearchView}/>
            <Route exact path='/:lang/404' component={NotFound}/>
            <Route path='' component={NotFound}/>
          </ConnectedSwitch>
        </main>
        <Footer/>
        <Navigation/>
        <SearchBar/>
        {
          this.state.showProgress &&
          <ProgressIndicator/>
        }
      </div>
    );
  }
}

export const App = connect(
  state => ({
    resolve_progress: state.resolve.resolve_progress
  }),
  dispatch => ({
    setLanguage: language => dispatch(setLanguage(language))
  })
)(AppContainer);



// WEBPACK FOOTER //
// ./src/App.js